import { FacturaCitrusService as service } from "services";
import { ResponseExceptionHandlerHelper } from "utils";


export const FacturaCitrusManager = (() => {
  const { handleException } = ResponseExceptionHandlerHelper();

  const listado = (where) => {
    return service.listado(where).then((res) => {
      if (!res.Success) {
        handleException(res);
      }
      return res;
    });
  };

  const obtenerLinkPagoFactura = (where) => {
    return service.obtenerLinkPagoFactura(where).then((res) => {
      if (!res.Success) {
        handleException(res);
      }
      return res;
    });
  };

  const actualizarFacturaRecurrente = (compania) => {
    return service.actualizarFacturaRecurrente(compania).then((res) => {
      if (!res.Success) {
        handleException(res);
      }
      return res;
    });
  };


  const actualizarPorNumeroFactura = (data) => {
    return service.actualizarPorNumeroFactura(data).then((res) => {
      if (!res.Success) {
        handleException(res);
      }
      return res;
    });
  };

  const descargarFormularioAutorizacionCargoTarjetaCredito = (tipoPlantilla) => {
    return service.descargarFormularioAutorizacionCargoTarjetaCredito(tipoPlantilla).then((res) => {
      if (!res.Success) {
        handleException(res);
      }
      return res.blob;
    });
  };


  const procesarFormularioAutorizacion = (data) => {
    return service.procesarFormularioAutorizacion({
      ...data,
      Files: data.File,
    }).then((res) => {
      if (!res.Success) {
        handleException(res);
      }
      return res.Data;
    });
  };

  const procesarComprobantePago = (data) => {
    return service.procesarComprobantePago({
      ...data,
      Files: data.File,
    }).then((res) => {
      if (!res.Success) {
        handleException(res);
      }
      return res.Data;
    });
  };

   const buscarReporte = (where) => {
    return service.buscarReporte(where).then((res) => {
      if (!res.Success) {
        handleException(res);
      }
      return res;
    });
  };


  return {
    listado,
    obtenerLinkPagoFactura,
    actualizarFacturaRecurrente,
    descargarFormularioAutorizacionCargoTarjetaCredito,
    procesarFormularioAutorizacion,
    procesarComprobantePago,
    actualizarPorNumeroFactura,
    buscarReporte
  };
})();
